<template>
	<main>
		<div id="app">
			<Maintenance v-if="isMaintenanceMode"></Maintenance>
			<Header @updateComponents="updateComponents"></Header>
			<transition name="fade" mode="out-in">
				<router-view :key="`${compontentsKey}_${$router.fullPath}`" />
			</transition>
			<Footer></Footer>
			<Popups></Popups>
		</div>

		<notifications group="globalNotifications" position="bottom left" />
	</main>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Maintenance from '@/components/Maintenance.vue'
import Popups from '@/components/Popups.vue'
const fb = require('@/firebaseConfig.js')

export default {
	metaInfo(){
		return{
			title: this.$route.name,
			titleTemplate: '%s | OneMgl',
			meta: [
				{
					property: 'author',
					content: 'Anand Davaasuren'
				},
				{
					property: 'description',
					content: 'Mongolian Community in Canada'
				},
				{
					property: 'og:title',
					content: this.$route.name,
					template: '%s | OneMgl',
					vmid: 'og:title'
				},
				{
					property: 'og:image',
					content: 'https://images.prismic.io/vanmglcom/9e69f78b-8745-4ed2-927c-7ef368f40caa_121015585_161076802317459_1571058744175153775_o.png'
				},
				{
					property: 'og:url',
					content: this.$route.path,
					template: 'https://www.onemgl.com%s'
				},
				{
					property: 'og:description',
					content: 'Mongolian Community in Canada'
				},
				{
					property: 'og:image:type',
					content: 'image/png'
				},
				{
					property: 'og:locale',
					content: 'en_US'
				},
				{
					property: 'og:type',
					content: 'website'
				},
				{
					property: 'og:site_name',
					content: 'OneMgl'
				},
				{
					property: 'fb:app_id',
					content: '530491014314573'
				},
				{
					property: 'twitter:title',
					content: this.$route.name,
					template: '%s | OneMgl'
				},
				{
					property: 'twitter:description',
					content: 'Mongolian Community in Canada'
				},
				{
					property: 'twitter:card',
					content: 'summary_large_image'
				},
				{
					property: 'twitter:image',
					content: 'https://images.prismic.io/vanmglcom/9e69f78b-8745-4ed2-927c-7ef368f40caa_121015585_161076802317459_1571058744175153775_o.png'
				}
			],
			link: [
				{
					rel: 'canonical',
					href: `https://www.onemgl.com${this.$route.path}`,
				}
			]
		}
	},
	
	data(){
		return{
			isMaintenanceMode: false,
			compontentsKey: 0,
			showPopups: false,
			popupType: ''
		}
	},

	components: {
		Header,
		Footer,
		Maintenance,
		Popups
	},

	created(){
		if(this.$store.state.currentUser !== null){
			// User Online Presence
			let userStatusRef = fb.rdb.ref(`/status/${this.$store.state.currentUser.uid}`)

			// Connected
			fb.rdb.ref('.info/connected').on('value', snapshot => {
				if(this.$store.state.currentUser !== null){
					userStatusRef.set({
						status: 'online',
						timestamp: fb.firebase.database.ServerValue.TIMESTAMP
					})
				}
			})
			// Disconnected
			userStatusRef.onDisconnect().set({
				status: 'offline',
				timestamp: fb.firebase.database.ServerValue.TIMESTAMP
			})

			// User Location
			if(this.$store.state.userProfile !== null){
				this.checkUserLocation()
			}
		}
	},
	
	methods: {
		updateComponents(){
			this.$forceUpdate()
			this.compontentsKey += 1
		},
		async checkUserLocation(){
			let userProfile = this.$store.state.userProfile
			let userRef = fb.usersCollection.doc(this.$store.state.currentUser.uid)

			// console.log('Check user location: ', userProfile.systemLocation)

			// Get User Ip Address
			let userIpAddress = ''

			if(typeof userProfile.ipaddress === 'undefined'){
				userIpAddress = await this.getUserIpAddress()

				let updates = {
					ipaddress: userIpAddress
				}
				userRef.update(updates).then(() => {
					console.log('Successfully saved user ip address: ', updates)
				})

				console.log('User new ip address: ', userIpAddress)
			}else{
				userIpAddress = userProfile.ipaddress

				// console.log('User saved ip address: ', userIpAddress)
			}

			// Check if geo location is set
			if(typeof userProfile.systemLocation !== 'undefined' && userProfile.systemLocation !== null){
				console.log('User location is already set! ', userProfile.systemLocation)
				return
			}

			// Get User System Location Data
			let userLocationData = await this.getUserLocationData(userIpAddress)

			console.log('User location data to save: ', userLocationData)

			let updates = {
				systemLocation: userLocationData
			}

			userRef.update(updates).then(() => {
				console.log('Successfully added user system location data: ', updates)
			})
		},
		async getUserLocationData(ipaddress){
			// API Usage: https://ipstack.com/usage
			return this.$http.get(`http://api.ipstack.com/${ipaddress}?access_key=68b71a5f001d740be62f735ab9118364`).then(response => {
				if(response.status === 200){
					return response.body
				}else{
					console.log('Error getting location data: ', response)
					return null
				}
			}).catch(err => {
				console.log('Error getting location data: ', err)
				return null
			})
		},
		async getUserIpAddress(){
			// Docs: https://www.ipify.org
			return fetch('https://api.ipify.org?format=json')
				.then(x => x.json())
				.then(({ ip }) => {
					return ip
				})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/App.vue